<div class="app-container" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <!-- Header para usuarios NO autenticados -->
  <header class="header header-public" *ngIf="currentRoute !== '/login' && !isAuthenticated">
    <div class="header-content header-content-public">
      <!-- Lado izquierdo: Toggle de tema, Logo y Título -->
      <div class="header-left-public">
        <button class="theme-toggle theme-toggle-public" (click)="toggleTheme()" [attr.aria-label]="isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
          <svg *ngIf="isDarkMode" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
          <svg *ngIf="!isDarkMode" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        </button>
        <div class="logo-title-wrapper" (click)="goToHome()">
          <img *ngIf="isDarkMode" src="assets/logobn.png" alt="Logo" class="header-logo">
          <img *ngIf="!isDarkMode" src="assets/logo.png" alt="Logo" class="header-logo">
          <h1 class="main-title">Punto de Fuga</h1>
        </div>
      </div>

      <!-- Centro: Menú de navegación (Desktop) -->
      <div class="header-center-public desktop-menu">
        <button (click)="goToCasosUso()" class="menu-link" [class.active]="currentRoute === '/casos-uso'">
          Casos de Uso
        </button>
        <button (click)="goToPricing()" class="menu-link" [class.active]="currentRoute === '/pricing'">
          Suscripciones
        </button>
        <button (click)="goToPrivacy()" class="menu-link" [class.active]="currentRoute === '/privacy'">
          Aviso de Privacidad
        </button>
        <button (click)="goToSupport()" class="menu-link" [class.active]="currentRoute === '/support'">
          Soporte
        </button>
      </div>

      <!-- Lado derecho: Botón de Login y Menú Hamburguesa (Móvil) -->
      <div class="header-right-public">
        <button 
          (click)="goToLogin()" 
          class="btn-login-header"
          title="Iniciar sesión"
        >
          Iniciar Sesión
        </button>
        <button 
          (click)="toggleMobileMenu()" 
          class="mobile-menu-toggle"
          [class.active]="isMobileMenuOpen"
          title="Menú"
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
    
    <!-- Menú móvil desplegable -->
    <div class="mobile-menu-overlay" [class.open]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>
    <nav class="mobile-menu" [class.open]="isMobileMenuOpen">
      <button 
        (click)="goToCasosUso(); closeMobileMenu()" 
        class="mobile-menu-link" 
        [class.active]="currentRoute === '/casos-uso'"
      >
        Casos de Uso
      </button>
      <button 
        (click)="goToPricing(); closeMobileMenu()" 
        class="mobile-menu-link" 
        [class.active]="currentRoute === '/pricing'"
      >
        Suscripciones
      </button>
      <button 
        (click)="goToPrivacy(); closeMobileMenu()" 
        class="mobile-menu-link" 
        [class.active]="currentRoute === '/privacy'"
      >
        Aviso de Privacidad
      </button>
      <button 
        (click)="goToSupport(); closeMobileMenu()" 
        class="mobile-menu-link" 
        [class.active]="currentRoute === '/support'"
      >
        Soporte
      </button>
    </nav>
  </header>

  <!-- Header - Solo mostrar si está autenticado y no está en login -->
  <header class="header" *ngIf="currentRoute !== '/login' && isAuthenticated">
    <div class="header-content">
      <!-- Lado izquierdo: Botones de acción -->
      <div class="header-left">
        <button (click)="toggleSidebar()" class="menu-toggle" title="Abrir menú">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <button class="theme-toggle" (click)="toggleTheme()" [attr.aria-label]="isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
          <svg *ngIf="isDarkMode" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
          <svg *ngIf="!isDarkMode" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        </button>
      </div>

      <!-- Centro: Logo y Título -->
      <div class="header-center">
        <div class="logo-title-wrapper">
          <img *ngIf="isDarkMode" src="assets/logobn.png" alt="Logo" class="header-logo">
          <img *ngIf="!isDarkMode" src="assets/logo.png" alt="Logo" class="header-logo">
          <h1 class="main-title">Punto de Fuga</h1>
        </div>
      </div>

      <!-- Lado derecho: Usuario -->
      <div class="header-right">
        <!-- Perfil del usuario si está autenticado -->
        <div *ngIf="isAuthenticated && userName" class="user-profile">
          
          <div class="user-details">
            <div class="user-name-text">{{ userEmail }}</div>
            <!-- <div class="user-email-text" *ngIf="userEmail"></div> -->
          </div>
          <button 
            (click)="logout()" 
            class="btn-logout-icon"
            title="Cerrar sesión"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </div>
  </header>

  <!-- Sidebar/Menú lateral - Solo mostrar si está autenticado y no está en login -->
  <aside 
    class="sidebar" 
    [class.sidebar-open]="isSidebarOpen" 
    [style.width.px]="sidebarWidth"
    *ngIf="currentRoute !== '/login' && isAuthenticated"
  >
    <div 
      class="sidebar-resizer"
      (mousedown)="onResizeStart($event)"
      [class.resizing]="isResizing"
    ></div>
    <nav class="sidebar-nav">
      <button 
        class="sidebar-item" 
        [class.active]="isActiveRoute('/home')"
        (click)="goToHome()"
      >
        <svg class="sidebar-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
        <span>Procesador de Imágenes</span>
      </button>
      
      <button 
        class="sidebar-item" 
        [class.active]="isActiveRoute('/banner-editor')"
        (click)="goToBannerEditor()"
      >
        <svg class="sidebar-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="21" x2="9" y2="9"></line>
        </svg>
        <span>Editor de Banners - Flyer</span>
      </button>

      <!-- Sección de Mis Imágenes -->
      <div class="projects-section">
        <h3 class="projects-section-title">Mis Imágenes</h3>
        
        <!-- Lista de imágenes -->
        <div class="projects-list" *ngIf="misImagenes.length > 0">
          <div 
            *ngFor="let imagen of misImagenes" 
            class="sidebar-item project-item"
            (click)="abrirImagen(imagen)"
          >
            <button 
              class="project-item-button"
              type="button"
            >
              <svg class="sidebar-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21 15 16 10 5 21"></polyline>
              </svg>
              <span class="project-name">{{ getImageName(imagen.url_image) }}</span>
            </button>
          </div>
        </div>
        
        <div *ngIf="misImagenes.length === 0 && !loadingImagenes" class="empty-images-message">
          <p>No tienes imágenes cargadas</p>
        </div>
      </div>

      <!-- Sección de Proyectos -->
      <div class="projects-section">
        <h3 class="projects-section-title">Proyectos</h3>
        <button 
          class="sidebar-item new-project-btn" 
          (click)="showNewProjectModal = true"
        >
          <svg class="sidebar-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
            <line x1="12" y1="11" x2="12" y2="17"></line>
            <line x1="9" y1="14" x2="15" y2="14"></line>
          </svg>
          <span>Nuevo proyecto</span>
        </button>

        <!-- Lista de proyectos -->
        <div class="projects-list" *ngIf="proyectos.length > 0">
          <div 
            *ngFor="let proyecto of proyectos" 
            class="project-item-wrapper"
            [class.editing]="isEditingProyecto(proyecto.Id)"
          >
            <!-- Vista normal del proyecto -->
            <div 
              *ngIf="!isEditingProyecto(proyecto.Id)"
              class="sidebar-item project-item"
              [class.active]="proyectoActivoId === proyecto.Id"
            >
              <button 
                class="project-item-button"
                (click)="abrirProyecto(proyecto)"
                type="button"
              >
                <svg class="sidebar-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" [attr.stroke]="getProjectColor(proyecto)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                </svg>
                <span class="project-name">{{ proyecto.Nombre }}</span>
              </button>
              <div class="project-actions">
                <button 
                  class="project-action-btn rename-btn"
                  (click)="startEditingProyecto(proyecto); $event.stopPropagation()"
                  title="Renombrar"
                  type="button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button 
                  class="project-action-btn delete-btn"
                  (click)="deleteProyecto(proyecto); $event.stopPropagation()"
                  title="Eliminar"
                  type="button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
              <button 
                class="project-expand-btn"
                (click)="toggleProyectoExpand(proyecto, $event)"
                type="button"
                title="Expandir/Colapsar"
              >
                <svg class="expand-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="isProyectoExpanded(proyecto.Id)">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
            
            <!-- Lista de elementos del proyecto (cuando está expandido) -->
            <div *ngIf="isProyectoExpanded(proyecto.Id) && !isEditingProyecto(proyecto.Id)" class="project-elements-list">
              <div *ngIf="isLoadingElementos(proyecto.Id)" class="project-elements-loading">
                <span>Cargando elementos...</span>
              </div>
              <div *ngIf="!isLoadingElementos(proyecto.Id) && getProyectoElementos(proyecto.Id).length === 0" class="project-elements-empty">
                <span>No hay elementos en este proyecto</span>
              </div>
              <div 
                *ngFor="let elemento of getProyectoElementos(proyecto.Id); let i = index" 
                class="project-element-item"
                (click)="selectElementFromTree(proyecto.Id, i, getElementoNombre(elemento))"
                [class.active]="isElementSelected(proyecto.Id, i)"
              >
                <svg *ngIf="getElementoIcon(elemento) === 'text'" class="element-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="4 7 4 4 20 4 20 7"></polyline>
                  <line x1="9" y1="20" x2="15" y2="20"></line>
                  <line x1="12" y1="4" x2="12" y2="20"></line>
                </svg>
                <svg *ngIf="getElementoIcon(elemento) === 'image'" class="element-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
                <svg *ngIf="getElementoIcon(elemento) === 'shape'" class="element-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                </svg>
                <span class="element-name">{{ getElementoNombre(elemento) }}</span>
              </div>
            </div>
            
            <!-- Vista de edición inline -->
            <div *ngIf="isEditingProyecto(proyecto.Id)" class="project-edit-container">
              <svg class="sidebar-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <input 
                type="text" 
                [(ngModel)]="editingProyectoName"
                class="project-name-input"
                [disabled]="isRenaming"
                (keyup.enter)="!isRenaming && saveProyectoName()"
                (keyup.escape)="!isRenaming && cancelEditingProyecto()"
                autofocus
              />
              <div class="project-edit-actions">
                <button 
                  class="project-edit-btn save-btn"
                  (click)="saveProyectoName()"
                  [disabled]="isRenaming || !editingProyectoName || editingProyectoName.trim().length === 0"
                  title="Guardar"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </button>
                <button 
                  class="project-edit-btn cancel-btn"
                  (click)="cancelEditingProyecto()"
                  [disabled]="isRenaming"
                  title="Cancelar"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
      <!-- Botón Mejora tu plan al final del sidebar -->
      <div class="sidebar-footer">
        <button 
          class="sidebar-item sidebar-item-pricing" 
          (click)="goToPricing()"
          title="Ver planes de precios"
        >
          <span>Mejora tu plan</span>
        </button>
      </div>
    </nav>
  </aside>

  <!-- Overlay para cerrar sidebar en móvil (solo visible en pantallas pequeñas) -->
  <div class="sidebar-overlay" *ngIf="isSidebarOpen && currentRoute !== '/login' && isAuthenticated" (click)="toggleSidebar()"></div>

  <!-- Modal para nuevo proyecto -->
  <div class="modal-overlay" *ngIf="showNewProjectModal" (click)="showNewProjectModal = false">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Nuevo Proyecto</h2>
        <button class="modal-close" (click)="showNewProjectModal = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <p>Selecciona el tipo de proyecto que deseas crear:</p>
        <div class="project-type-options">
          <button class="project-type-btn" (click)="crearProyectoBanner()">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="3" y1="9" x2="21" y2="9"></line>
              <line x1="9" y1="21" x2="9" y2="9"></line>
            </svg>
            <span>Editor de Banner - Flyer</span>
          </button>
          <button class="project-type-btn" (click)="crearProyectoProcesador()" disabled>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
            <span>Procesador de Imágenes</span>
            <small>Próximamente</small>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Contenido principal -->
  <main class="main-content" [class.sidebar-open]="isSidebarOpen && isAuthenticated">
    <router-outlet></router-outlet>
  </main>
</div>
